module.exports = __webpack_public_path__ + "static/media/serv-2.af35bc4a.jpg";